/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindPrebidImportBufferEntriesResponseDto } from '../../models/find-prebid-import-buffer-entries-response-dto';
import { PrebidImportBufferReason } from '../../models/prebid-import-buffer-reason';

export interface FindPrebidImportBufferEntries$Params {
  '$page': number;
  '$maxpagesize': number;
  source?: string;
  reason?: PrebidImportBufferReason;
  'X-API-Version'?: string;
}

export function findPrebidImportBufferEntries(http: HttpClient, rootUrl: string, params: FindPrebidImportBufferEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<FindPrebidImportBufferEntriesResponseDto>> {
  const rb = new RequestBuilder(rootUrl, findPrebidImportBufferEntries.PATH, 'get');
  if (params) {
    rb.query('$page', params['$page'], {});
    rb.query('$maxpagesize', params['$maxpagesize'], {});
    rb.query('source', params.source, {});
    rb.query('reason', params.reason, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindPrebidImportBufferEntriesResponseDto>;
    })
  );
}

findPrebidImportBufferEntries.PATH = '/api/prebid-import/buffer';
